import { isNonEmptyArray } from "../../../../../utils";

export function getFilteredItems(obj, getSelectedOption) {
	const items = obj?.items ?? [];
	const optionDependencies = obj?.optionDependencies;
	if (!isNonEmptyArray(optionDependencies)) {
		return items;
	}
	const allowedSets = optionDependencies.map((dep) => {
		const selectedOptions = [getSelectedOption?.(dep?.fieldId)].flat().filter(Boolean);
		const unionSet = new Set(
			selectedOptions.flatMap((selected) => {
				const match = dep?.conditions?.find((f) => f?.selectedOptionId === selected);
				return match?.allowedOptionIds ?? [];
			})
		);
		return unionSet.size > 0 ? unionSet : null;
	});
	const validSets = allowedSets.filter(Boolean);
	if (!validSets.length) {
		return items;
	}
	const intersection = validSets.reduce((acc, set) => new Set([...acc].filter((uuid) => set.has(uuid))));
	return items.filter((item) => item?.uuid && intersection.has(item.uuid));
}
